import React from 'react';
import { Breadcrumb, notification } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import TablaTipoExpedientes from './TablaTipoExpedientes';

import getTipoExpedientes from '../../../graphql/querys/contravenciones/getTipoExpedientes.graphql';
import deleteTipoExpediente from '../../../graphql/mutations/contravenciones/deleteTipoExpediente.graphql';
@compose(
  graphql(getTipoExpedientes, {
    name: 'getTipoExpedientes',
  }),
  graphql(deleteTipoExpediente, {
    name: 'deleteTipoExpediente',
    options: {
      refetchQueries: [{ query: getTipoExpedientes }],
    },
  })
)
class VerTipoExpediente extends React.Component {
  state = {
    persona: {},
    step: 0,
    guardado: false,
    loading: false,
    expediente: {},
  };

  onDelete = id => {
    console.log('ME LLEGA: ', id);
    this.props
      .deleteTipoExpediente({
        variables: {
          _id: id,
        },
      })
      .then(respuesta => {
        // console.log('LA RESPUESTA QUE ME LLEGA ES: ');
        // console.log(respuesta);
        if (respuesta.data.deleteTipoExpediente) {
          notification.warning({
            message: 'Eliminacion Correcta',
            description: 'Se eliminó correctamente el tipo de expediente',
          });
        }
      })
      .catch(err => {
        console.log('ERROR A LA HORA DE ELIMINAR TIPO DE EXPEDIENTE: ', err);
      });
  };
  render() {
    if (
      this.state.loading ||
      !this.props.getTipoExpedientes.getTipoExpedientes
    ) {
      return <Loading />;
    }

    let listaTipoExpedientes = this.props.getTipoExpedientes.getTipoExpedientes;

    if (!listaTipoExpedientes) {
      listaTipoExpedientes = [];
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Expedientes</Breadcrumb.Item>
          <Breadcrumb.Item>Nuevo</Breadcrumb.Item>
        </Breadcrumb>
        <div>
          <TablaTipoExpedientes
            tipoExpedientes={listaTipoExpedientes}
            history={this.props.history}
            onDelete={this.onDelete}
          />
        </div>
      </div>
    );
  }
}

export default withApollo(VerTipoExpediente);
